<template>
  <div>
    <div class="input-container" v-if="!optInPreviouslyChecked">
      <label>
        <span>
          Yes, I would like to receive future product news and announcements
          electronically from Nissan
        </span>
        <input
          v-model="optIn"
          type="checkbox"
          class="nissan-quiz-input"
          id="nissan-quiz-receive-newsletter"
          name="optIn"
          :disabled="optInPreviouslyChecked"
        />
        <span class="checkmark" />
      </label>
    </div>
    <div class="input-container" v-if="!leadPreviouslyChecked">
      <label>
        <span>Have a dealer contact me for a test drive</span>
        <input
          v-model="lead"
          type="checkbox"
          class="nissan-quiz-input"
          id="nissan-quiz-receive-contact"
          name="lead"
          :disabled="leadPreviouslyChecked"
        />
        <span class="checkmark" />
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UserOptInOptions',
  data() {
    return {
      optInPreviouslyChecked: this.$store.state.optIn,
      leadPreviouslyChecked: this.$store.state.lead,
    };
  },
  computed: {
    ...mapGetters([
      'config',
    ]),
    optIn: {
      get() {
        return this.$store.state.optIn;
      },
      set(value) {
        this.$store.commit('setOptIn', { value });
      },
    },
    lead: {
      get() {
        return this.$store.state.lead;
      },
      set(value) {
        this.$store.commit('setLead', { value });
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/_variables.scss";
@import "../../styles/_reset.scss";

div:has(.input-container) {
  margin: 24px auto;
  width: 85%;

  @media only screen and (min-width: 600px) {
    margin: 48px auto;
    width: 75%;
  }
}
div.input-container {
  position: relative;
  & + & {
    margin-top: 36px;
  }
  label {
    user-select: none;
    span:first-of-type {
      display: block;
      padding-left: 55px;
      font-size: 16px;

      @media only screen and (min-width: 600px) {
        font-size: 25px;
      }
    }
    input.nissan-quiz-input {
      display: none;
    }
    span.checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 35px;
      width: 35px;
      border: 1.5px solid #fff;

      &:after {
        content: "";
        position: absolute;
        display: none;
      }
    }
    input:checked + span.checkmark:after {
      display: block;
      left: 9px;
      width: 12.5px;
      height: 25px;
      border: solid white;
      border-width: 0 3px 3px 0;
      transform: rotate(45deg);
    }
  }
}
</style>
